export default "__VITE_ASSET__WgwW5vJX__"